import duplicateCurriculumModalEn from "./locales/en.json";

export const DUPLICATE_CURRICULUM_MODAL_NS =
  "duplicateCurriculumModal" as const;

export const DuplicateCurriculumModalTranslations = {
  en: {
    [DUPLICATE_CURRICULUM_MODAL_NS]: {
      ...duplicateCurriculumModalEn,
    },
  },
};
